module.exports = "/_next/static/images/buc-2a1ef162f458aadfa27f52420f2d8131.jpg.webp";